// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__7FJBr","main":"Contact_main__xXsN4","info":"Contact_info__4M3u9","img":"Contact_img__aqRu+"};